/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { InputLabel, MenuItem, Select } from '@mui/material';
import { type ReactNode } from 'react';

import { type EditorLanguage, getLanguages } from './languages';
import type { LanguageSelectionProps } from './types';

export function LanguageSelection( { activeEditorLanguage, setLocalEditorLanguage }: LanguageSelectionProps ): ReactNode {
	const languages = getLanguages();

	return (
		<div>
			<InputLabel id={ 'installation-sidebar-language' }>Language</InputLabel>
			<Select
				labelId={ 'installation-sidebar-language' }
				label={ 'Language' }
				sx={ { width: '100%', '& .MuiOutlinedInput-notchedOutline': { borderColor: 'secondary.400' } } }
				value={ activeEditorLanguage }
				onChange={ event => setLocalEditorLanguage( event.target.value as EditorLanguage ) }
				data-testid={ 'ckeditor5-language-select' }
			>
				{ languages.map( language => (
					<MenuItem
						key={ language.code }
						value={ language.code }
						data-testid={ `ckeditor5-language-select-item-${ language.code }` }
						sx={ { fontSize: '14px' } }
					>
						{ language.displayName }
					</MenuItem>
				) ) }
			</Select>
		</div>
	);
}
